import ImgCzujnik from './czujnik.png';
//import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Login from "../Login";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import React, { Suspense } from 'react';
import CopyButton from './CopyButton';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Paper from '@mui/material/Paper';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';

import { useTranslation } from "react-i18next";

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  textAlign: 'center',
  color: theme.palette.text.secondary,

}));



const homeStyle = {
  display:'flex',
  justifyContent:'center',
  alignItems:'center',

};
const imgStyle = {
  width: "40%"
};


 function Help() {

   const { t } = useTranslation("common");

   return (

     <div>
     <Container maxWidth="sm">

<br/>
<br/>


           <Box
             sx={{
               p: 2,
               bgcolor: 'background.default',
            
               gap: 2,
             }}
           >

               <Item elevation='24'>
               <Typography variant="span">
               SMARTSENSING
               <br/>
               SPÓŁKA Z OGRANICZONĄ
               ODPOWIEDZIALNOŚCIĄ
               <br/>
               Towarowa 13
               <br/>
               11-041 Olsztyn
               <br/>
               NIP: 7393975712
               </Typography>
               </Item>

           </Box>




<br/>

    </Container>
  </div>

  );
 }
export default function App() {
  return (
      <Help />
  );
}

//https://www.codeandweb.com/babeledit/tutorials/how-to-translate-your-react-app-with-react-i18next
